import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { set } from "lodash";
import { defaultFormData, initialState } from "./initialState";
import { ENUM_USER_STATUS, IData, IUserOrderData } from "../types";
import { DataActiveStatusEnum } from "../../Category/types";
import { DateTime } from "luxon";

export const useClinicSlice = createSlice({
  name: "userState",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setButtonLoading: (state, action: PayloadAction<boolean>) => {
      state.buttonLoading = action.payload;
    },
    setToggleLoading: (state, action: PayloadAction<boolean>) => {
      state.toggleLoading = action.payload;
    },
    setSearch: (state, action: PayloadAction<string>) => {
      state.search = action.payload;
    },
    setPageNo: (state, action: PayloadAction<number>) => {
      state.pageNo = action.payload;
    },
    setPageSize: (state, action: PayloadAction<number>) => {
      state.pageSize = action.payload;
    },
    setTotalRow: (state, action: PayloadAction<number>) => {
      state.totalRow = action.payload;
    },

    setOrderDir: (state, action: PayloadAction<string>) => {
      state.orderDir = action.payload;
    },
    setOrderBy: (state, action: PayloadAction<string>) => {
      state.orderBy = action.payload;
    },

    updateFormValue: (
      state,
      action: PayloadAction<{ key: string; value: any }>
    ) => {
      set(state, `formData.${action.payload.key}`, action.payload.value);
    },
    clearFrom: (state) => {
      state.formData = { ...defaultFormData };
    },

    doUpdateImportant: (
      state,
      action: PayloadAction<{
        id: string;
        index: number;
        callback: () => void;
      }>
    ) => {},
    doUpdateStatus: (
      state,
      action: PayloadAction<{
        id: string;
        index: number;
        callback: () => void;
      }>
    ) => {
      state.list[action.payload.index].status =
        state.list[action.payload.index].status === ENUM_USER_STATUS.ACTIVE
          ? ENUM_USER_STATUS.INACTIVE
          : ENUM_USER_STATUS.ACTIVE;
    },

    doGetById: (state, action: PayloadAction<string>) => {
      state.loading = true;
    },
    doGetList: (state) => {
      if (!state.toggleLoading) {
        state.loading = true;
      }
    },
    doGetOrderList: (state, action: PayloadAction<string>) => {},
    setOrderPageNo: (state, action: PayloadAction<number>) => {
      state.orderPageNo = action.payload;
    },
    setOrderPageSize: (state, action: PayloadAction<number>) => {
      state.orderPageSize = action.payload;
    },
    setOrderTotalRow: (state, action: PayloadAction<number>) => {
      state.orderTotalRow = action.payload;
    },
    setOrderList: (state, action: PayloadAction<Array<IUserOrderData>>) => {
      state.orders = action.payload;
    },
    setList: (state, action: PayloadAction<Array<IData>>) => {
      state.list = action.payload;
    },
    setDataForm: (state, action: PayloadAction<IData>) => {
      state.formData = action.payload;
    },
    setEndDate: (state, action: PayloadAction<DateTime | null>) => {
      state.endDate = action.payload;
    },
    setStartDate: (state, action: PayloadAction<DateTime | null>) => {
      state.startDate = action.payload;
    },
    doUpdate: (state, action: PayloadAction<{ callback: () => void }>) => {},
  },
});

export const { reducer, actions, name: sliceKey } = useClinicSlice;
